import React from "react";
import { init } from "@noriginmedia/norigin-spatial-navigation";
import { Menu } from "../layout/sidebar";
import GridContent from "./content-grid/content";
import GenreChildPageSkeleton from "../common/Skeleton/GenreChildPageSkeleton";

init({
  debug: false,
  visualDebug: false,
  rtl: true,
});

export default function SpitialProfileFavourties({ data, loading = false }) {
  return (
    <div className="legacy-app-shell">
      <div className="legacy-app-shell-sidebar">
        <Menu focusKey="MENU" />
      </div>
      <div className="legacy-app-shell-content">
        {loading ? (
          <GenreChildPageSkeleton isParent={false} rows={3} cols={5} />
        ) : (
          <GridContent data={data} title="نشان شده ها" />
        )}
      </div>
    </div>
  );
}
